import { ReduxHelper } from "helpers";

export const prefix = "APP_CONFIG";

export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
